import { render, staticRenderFns } from "./Staff2fa.vue?vue&type=template&id=6edf4f92&"
import script from "./Staff2fa.vue?vue&type=script&lang=js&"
export * from "./Staff2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports